import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";

interface popupProps {
  cdBiz?: String;
}

const SN_MAS_ORG_REG_002_POP_01 = forwardRef(
  ({ cdBiz }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridApiRefH = useRef<any>(null); // 첫 번째  그리드 Reference 변수
    const gridApiRefL = useRef<any>(null); // 두 번째  그리드 Reference 변수
    //#endregion

    //#region Components useState
    const [columns1, setColums1] = useState<any[]>([]);
    const [columns2, setColums2] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const [dataSource2, setDataSource2] = useState<any[]>([]);
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [
        gridApiRefH.current.getSelectedRows() || [],
        gridApiRefL.current.getSelectedRows() || [],
      ],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_MAS_ORG_REG_002_POP_01", {});
          setColums1(rtn.grid.grid1); // H그리드 항목 설정
          setColums2(rtn.grid.grid2); // L그리드 항목 설정
          onSearch();
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    const onSearch = async () => {
      try {
        const params = {
          id: "sn_mas_org_reg_002_pop_01_01",
          params: { cd_firm: userInfo.cd_firm, cd_biz_tax: cdBiz },
        };

        setDataSource1([]);
        setDataSource2([]);
        const data: any = await fnGetDataSet(params);
        setDataSource1(data[0]);
        setDataSource2(data[1]);

        if (data[0] && data[0].length > 0) {
          // 1. 그리드 데이터가 바인딩되었음을 기다림
          await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

          // 2. 첫 번째 행 선택 및 포커스 설정
          gridApiRefH.current.selectAndFocusRow(0);
        }

        gridApiRefH.current.resetUpdate();
        gridApiRefL.current.resetUpdate();
      } catch (error) {}
    };
    //#endregion

    //#region Event Method
    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event; // 클릭한 행 데이터
      if (selectedRow) {
        // 배열로 만들어서 필터링 함수 호출
        const cd_biz_master = selectedRow.cd_biz_master;
        gridApiRefL.current.applyFilters({ cd_biz_tax: cd_biz_master });
        gridApiRefL.current.selectAndFocusRow(0);
        //gridApiRefL.current.selectAllFiltered();
      } else {
        return;
      }
    };
    //#endregion

    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <div style={{ display: "flex", gap: "10px", flex: 1 }}>
          <div style={{ flex: 1 }}>
            <SnGrid
              seq={1}
              ref={gridApiRefH}
              columnConfig={columns1}
              rowData={dataSource1}
              rowSelection="single"
              isEditable={false}
              enableAddRow={false}
              onFocusedRowChanged={onFocusedRowChanged}
              cellSelection={false}
            />
          </div>
          <div style={{ flex: 1 }}>
            <SnGrid
              seq={2}
              ref={gridApiRefL}
              columnConfig={columns2}
              rowData={dataSource2}
              rowSelection="single"
              isEditable={false}
              enableAddRow={false}
              cellSelection={false}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_MAS_ORG_REG_002_POP_01;
